import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { containerActions } from './actions';

import './styles.scss';

// const Notification = () => ;

class NotificationLoadScreen extends React.Component {
  render() {
    const { opened } = this.props;

    return opened && (
    <div className={`notificationLoading ${opened && 'active'}`}>
      <div className="loader" />
    </div>
    );
  }
}

NotificationLoadScreen.propTypes = {
  opened: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  opened: state.loadscreen.opened
});

export default connect(mapStateToProps, containerActions)(NotificationLoadScreen);



// WEBPACK FOOTER //
// ./src/components/LoadScreen/index.js